import { useContext } from 'react'
import { FlowContext } from '../contexts'

export const useFlowContext = () => useContext(FlowContext)
